(() => {
  const SELECTOR = '.custom-mega-menu';

  function initMenu(details) {
    if (details.dataset.hoverReady === 'true') return;

    const wrapper = details.closest('.header-wrapper');
    const content = details.querySelector('.custom-mega-menu__content');
    const topLink = details.querySelector('[data-custom-mega-menu-top-link]');
    if (!wrapper || !content) return;

    details.dataset.hoverReady = 'true';
    wrapper.appendChild(content);

    let closeTimer;

    const syncState = () => {
      content.classList.toggle('is-open', details.open);
      content.setAttribute('aria-hidden', details.open ? 'false' : 'true');
    };

    const open = () => {
      if (!window.matchMedia('(min-width: 990px)').matches) return;
      window.clearTimeout(closeTimer);
      document.querySelectorAll(`${SELECTOR}[open]`).forEach((menu) => {
        if (menu !== details) menu.removeAttribute('open');
      });
      details.setAttribute('open', '');
      syncState();
    };

    const scheduleClose = () => {
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(() => {
        details.removeAttribute('open');
        syncState();
      }, 140);
    };

    details.addEventListener('mouseenter', open);
    details.addEventListener('mouseleave', scheduleClose);
    details.addEventListener('focusin', open);
    details.addEventListener('focusout', (event) => {
      if (!details.contains(event.relatedTarget)) scheduleClose();
    });

    content.addEventListener('mouseenter', () => window.clearTimeout(closeTimer));
    content.addEventListener('mouseleave', scheduleClose);
    content.addEventListener('focusin', () => window.clearTimeout(closeTimer));
    content.addEventListener('focusout', (event) => {
      if (!content.contains(event.relatedTarget)) scheduleClose();
    });

    details.addEventListener('toggle', syncState);
    topLink?.addEventListener('click', (event) => {
      // Keep the native anchor navigation while preventing the parent summary
      // from toggling the details element on click.
      event.stopPropagation();
    });
    syncState();
  }

  const initAll = (root = document) => root.querySelectorAll(SELECTOR).forEach(initMenu);

  function initMobileCollectionBar(root = document) {
    const bars = root.matches?.('.custom-mobile-collections')
      ? [root]
      : [...root.querySelectorAll('.custom-mobile-collections')];

    bars.forEach((bar) => {
      if (bar.dataset.visibilityReady === 'true') return;

      const wrapper = bar.closest('.header-wrapper');
      if (!wrapper) return;

      const drawer = wrapper.querySelector('#Details-menu-drawer-container');
      let frame;
      let heightTimer;

      bar.dataset.visibilityReady = 'true';

      const updateHeaderHeight = () => {
        window.clearTimeout(heightTimer);
        heightTimer = window.setTimeout(() => {
          const headerSection = wrapper.closest('.section-header') || document.querySelector('.section-header');
          if (headerSection) {
            document.documentElement.style.setProperty('--header-height', `${headerSection.offsetHeight}px`);
          }
        }, 330);
      };

      const updateVisibility = () => {
        window.cancelAnimationFrame(frame);
        frame = window.requestAnimationFrame(() => {
          const isMobile = window.matchMedia('(max-width: 989px)').matches;
          const shouldHideForScroll = isMobile && window.scrollY > 4;
          const shouldHideForDrawer = isMobile && Boolean(drawer?.open);

          bar.classList.toggle('is-scroll-hidden', shouldHideForScroll);
          bar.classList.toggle('is-drawer-hidden', shouldHideForDrawer);
          updateHeaderHeight();
        });
      };

      window.addEventListener('scroll', updateVisibility, { passive: true });
      window.addEventListener('resize', updateVisibility);
      drawer?.addEventListener('toggle', updateVisibility);
      updateVisibility();
    });
  }

  function initMobileDrawerBounds(root = document) {
    const drawers = root.matches?.('#Details-menu-drawer-container')
      ? [root]
      : [...root.querySelectorAll('#Details-menu-drawer-container')];

    drawers.forEach((drawer) => {
      if (drawer.dataset.boundsReady === 'true') return;

      const wrapper = drawer.closest('.header-wrapper');
      const header = wrapper?.querySelector(':scope > header.header');
      if (!wrapper || !header) return;

      drawer.dataset.boundsReady = 'true';

      const updateBounds = () => {
        if (!window.matchMedia('(max-width: 989px)').matches) return;
        window.requestAnimationFrame(() => {
          const headerBottom = Math.max(0, header.getBoundingClientRect().bottom);
          wrapper.style.setProperty('--custom-mobile-header-bottom', `${headerBottom}px`);
        });
      };

      drawer.addEventListener('toggle', updateBounds);
      window.addEventListener('resize', updateBounds);
      window.addEventListener('scroll', updateBounds, { passive: true });
      updateBounds();
    });
  }

  const initEverything = (root = document) => {
    initAll(root);
    initMobileCollectionBar(root);
    initMobileDrawerBounds(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initEverything());
  } else {
    initEverything();
  }

  document.addEventListener('shopify:section:load', (event) => initEverything(event.target));
})();
